enum InternalRole {
	NONE = 'none',
	SALES = 'sales',
	ADMIN = 'admin',
}

export default InternalRole;